import { render } from "./EventGuestTitleBar.vue?vue&type=template&id=4a784d37&scoped=true&ts=true"
import script from "./EventGuestTitleBar.vue?vue&type=script&lang=ts"
export * from "./EventGuestTitleBar.vue?vue&type=script&lang=ts"

import "./EventGuestTitleBar.vue?vue&type=style&index=0&id=4a784d37&scoped=true&lang=css"

import exportComponent from "/Users/alcyone/Desktop/front/chapito-static/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a784d37"]])

export default __exports__